import classNames from 'classnames/bind';
import { gql } from '@apollo/client';
import styles from './AcfLeadGenForm.module.scss';
import { FormButton, FormInput, ToastList } from '@/components';
import { NetspendContext } from 'library/contexts/NetspendContext';
import { useContext, useState } from 'react';

let cx = classNames.bind(styles);

export default function AcfLeadGenForm(props) {
	const { leadGenForm, attributes, clientId } = props;
	const className = attributes.className?.split(' ') || [];

	const [email, setEmail] = useState('');
	const { setToastData } = useContext(NetspendContext);
	const { toastData } = useContext(NetspendContext);

	function handleOnSubmit(e) {
		if (!leadGenForm.formAction) e.preventDefault();
		if (leadGenForm.setBrazeEmail) {
			if (!leadGenForm.brazeLabel) {
				console.error('Braze label must be set in the Lead Gen Form.');
				return;
			}
			import('@/helpers/brazeExports')
				.then(({ logCustomEvent, getUser }) => {
					const brazeSetEmail = getUser().setEmail(email);
					getUser().addAlias(email, leadGenForm.brazeLabel);
					const brazeCustomEventCaptured = logCustomEvent(leadGenForm.brazeLabel, {
						date: new Date(),
					});
					return { brazeSetEmail, brazeCustomEventCaptured };
				})
				.then((brazeStatus) => {
					if (!brazeStatus.brazeSetEmail || !brazeStatus.brazeCustomEventCaptured) throw new Error('Braze capture error.');
				})
				.then(() => showToast(leadGenForm.toastMessages.success || 'Sign Up Successful', 'success'))
				.catch(() => showToast(leadGenForm.toastMessages.error || 'Sign Up Error', 'error'));
		}
	}

	function showToast(message, type) {
		const toast = {
			id: Date.now(),
			message,
			type,
		};

		setToastData((prevToastData) => [...prevToastData, toast]);
	}

	return (
		<>
			<ToastList data={toastData} />
			{leadGenForm && (
				<form id={attributes.anchor} method={leadGenForm.formAction && 'POST'} action={leadGenForm.formAction} className={cx(['ns_leadgen-form', 'leadgen-form', ...className, attributes.alignForm && `align-form-${attributes.alignForm}`])} onSubmit={(e) => handleOnSubmit(e)}>
					<FormInput type="email" name="email" id={`form-email-${clientId}`} label={leadGenForm.emailInputLabel || 'Email'} required={leadGenForm.emailRequired} value={email} setValue={setEmail} pattern="[a-zA-Z0-9.!#$%&’*+\/=?^_`\{\|\}~\-]+@[a-zA-Z0-9\-]+(?:\.[a-zA-Z0-9\-]+)+" />
					<FormButton type='submit' text={leadGenForm?.buttonText} />
				</form>
			)}
		</>
	);
}

AcfLeadGenForm.fragments = {
	key: `AcfLeadGenFormFragment`,
	entry: gql`
		fragment AcfLeadGenFormFragment on AcfLeadgenform {
			attributes {
				anchor
				alignForm: align
				className
			}
			clientId
			leadGenForm {
				buttonText
				brazeLabel
				emailInputLabel
				emailRequired
				formAction
				setBrazeEmail
				toastMessages {
					success
					error
				}
			}
		}
	`,
};

AcfLeadGenForm.config = {
	name: 'AcfLeadgenform',
};
AcfLeadGenForm.displayName = 'AcfLeadgenform';
